<template>
  <div class="p-6">
    <h2 class="text-xl font-semibold mb-4">E-Rezept</h2>
    
    <div class="text-sm text-gray-600 mb-4">
      <span class="mr-4">Vorname: {{ patient?.givenName }}</span>
      <span class="mr-4">Nachname: {{ patient?.surname }}</span>
      <span class="mr-4">Geburtsdatum: {{ formatDate(patient?.dateOfBirth) }}</span>
      <span>Versicherungsart: {{ patient?.insuranceInformations?.insuranceType }}</span>
    </div>
    
    <Muster16Form v-if="formType === 'Muster 16'" @save="saveERezept" />
    <Muster15Form v-if="formType === 'Muster 15'" @save="saveERezept" />
    <Muster12Form v-if="formType === 'Muster 12'" @save="saveERezept" />
    
    <BundleModal
      v-if="showBundle"
      :bundle="currentBundle"
      :createTaskResponse="createTaskResponse"
      @close="showBundle = false"
      @einstellen="einstellenERezept"
    />
    
    <MessageModal
      v-if="showMessage"
      :message="message"
      @close="showMessage = false"
    />
  </div>
</template>

<script>
import { ref, computed } from 'vue';
import { useDbStore } from '../stores/dbStore';
import Muster16Form from './Muster16/Muster16Form.vue';
import Muster15Form from './Muster15/Muster15Form.vue';
import Muster12Form from './Muster12/Muster12Form.vue';
import BundleModal from './BundleModal.vue';
import MessageModal from './MessageModal.vue';

export default {
  name: 'ERezept',
  components: {
    Muster16Form,
    Muster15Form,
    Muster12Form,
    BundleModal,
    MessageModal
  },
  props: {
    formType: {
      type: String,
      required: true
    }
  },
  setup() {
    const dbStore = useDbStore();
    const showBundle = ref(false);
    const showMessage = ref(false);
    const message = ref('');

    const patient = computed(() => dbStore.selectedPatient);
    const currentBundle = computed(() => dbStore.getCurrentBundle);
    const createTaskResponse = computed(() => dbStore.getCreateTaskResponse);
    

    const saveERezept = async () => {
      try {
        await dbStore.getCurrentBundle;
        showBundle.value = true;
      } catch (error) {
        console.error('Fehler beim Erstellen des E-Rezept Bundles:', error);
        message.value = 'Fehler beim Erstellen des E-Rezept Bundles';
        showMessage.value = true;
      }
    };

    const einstellenERezept = async () => {
      try {
        await dbStore.einstellenERezept();
        message.value = 'E-Rezept wurde erfolgreich eingestellt.';
        showMessage.value = true;
      } catch (error) {
        message.value = `Fehler beim Einstellen des E-Rezepts: ${error.message}`;
        showMessage.value = true;
      }
    };

    const formatDate = (dateString) => {
      const date = new Date(dateString);
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}.${month}.${year}`;
    };

    return {
      patient,
      currentBundle,
      createTaskResponse,
      showBundle,
      showMessage,
      message,
      saveERezept,
      einstellenERezept,
      formatDate
    };
  }
};
</script>